export class TasksRunner {
  private readonly tasksToAdd: Generator<void, void>[] = [];

  private readonly tasks: Generator<void, void>[] = [];

  public addTask(task: Generator<void, void>): void {
    this.tasksToAdd.unshift(task);
  }

  public hasAnyRunningTasks(): boolean {
    return this.tasks.length > 0 || this.tasksToAdd.length > 0;
  }

  public update(): void {
    if (this.tasksToAdd.length > 0) {
      this.tasks.splice(0, 0, ...this.tasksToAdd);
      this.tasksToAdd.length = 0;
    }

    for (let i = this.tasks.length - 1; i >= 0; i -= 1) {
      const result = this.tasks[i].next();
      if (result.done) {
        this.tasks.splice(i, 1);
      }
    }
  }
}
